import { toast } from 'react-toastify'
import {
  triggerDangerToast,
  triggerPrimaryToast,
  triggerSuccessToast,
  triggerWarningToast,
} from '@resurs/midas-react'
import {
  NOTIFY_DANGER,
  NOTIFY_DEFAULT,
  NOTIFY_PRIMARY,
  NOTIFY_SUCCESS,
  NOTIFY_WARNING,
} from './action-types'

import Errors from '../../models/errors'
import { getText } from '../../internal/TextLabels'

const calculateToastClose = message => {
  const messageLength = message.length

  const minDelay = 2500
  const maxDelay = 8000

  return Math.min(Math.max(messageLength * 50, minDelay), maxDelay)
}

const toastArgs = (message, noAutoClose, onClose, toastId) => {
  return {
    autoClose: noAutoClose ? false : calculateToastClose(message),
    onClose,
    toastId,
  }
}

const throttleTime = 500
let lastToast = { message: null, time: 0 }

export const notify = (data, message, noAutoClose, onClose, toastId) => {
  const currentTime = new Date().getTime()

  if (
    lastToast.message === message &&
    currentTime - lastToast.time < throttleTime
  ) {
    return
  }

  if (noAutoClose && lastToast.message) {
    return
  }

  lastToast = { message, time: currentTime }
  const errors = new Errors()

  if (data?.code) {
    switch (parseInt(data.code, 10)) {
      case errors.codes.authFailed.code:
        triggerWarningToast(
          getText(errors.codes.authFailed, data),
          toastArgs(getText(errors.codes.authFailed, data)),
        )
        break
      default:
        triggerPrimaryToast(
          getText(errors.codes.general),
          toastArgs(getText(errors.codes.general)),
        )
    }
  } else if (data?.status) {
    switch (data.status) {
      case errors.codes.notFound.code:
        triggerDangerToast(
          getText(errors.codes.notFound, data),
          toastArgs(getText(errors.codes.notFound, data)),
        )
        break
      default:
        triggerPrimaryToast(
          getText(errors.codes.general),
          toastArgs(getText(errors.codes.general)),
        )
    }
  } else {
    switch (data) {
      case NOTIFY_DEFAULT:
        triggerPrimaryToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
        break
      case NOTIFY_PRIMARY:
        triggerPrimaryToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
        break
      case NOTIFY_SUCCESS:
        triggerSuccessToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
        break
      case NOTIFY_WARNING:
        triggerWarningToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
        break
      case NOTIFY_DANGER:
        triggerDangerToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
        break
      default:
        triggerPrimaryToast(
          message,
          toastArgs(message, noAutoClose, onClose, toastId),
        )
    }
  }
}

export const dismiss = toastId => {
  toast.dismiss(toastId)
}
